import React, { createContext, useState } from "react";



export const MessageContext = createContext({})

const MessageProvider  = ({children}) => {
    const [errorMessage, setErrorMessage] = useState([])
    return(
        <MessageContext.Provider value={{  errorMessage , setErrorMessage}}>
            {children}
        </MessageContext.Provider>
    )

}

export default MessageProvider